import React, {useState} from 'react'
import * as Icon from 'react-feather';
const Alert = props => {
    const [visible, setVisible] = useState(props.isVisible)
    const alertClass = () =>{
        switch (props.type){
            case "secondary":
            return "bg-secondary border-secondary-dark"
            default:
            return "bg-primary border-primary-dark"
        }
    }
    return (
        <div className={`${alertClass()} ${visible ? '' : 'hidden'} border text-white p-4 fixed rounded-lg top-0 right-0 mt-6 mr-6`} style={{minWidth: 458}}>
            <div onClick={() => setVisible(!visible)} className="cursor-pointer absolute right-0 top-0 mr-4 mt-4">
                <Icon.X className="text-white" />
            </div>
            <h3 className="font-bold">{props.heading}</h3>
            <p dangerouslySetInnerHTML={{ __html: props.content }}></p>
        </div>
    )
}


export default Alert
